import React from 'react'
import { formatDateTime, priceFormatLocal } from 'utils/helper'

import { useStyles } from './style'
import { Box, Button } from '@mui/material'

const OrderListDeliveryItemMobile = ({ data, showDetail }) => {
  const styles = useStyles()

  const total =
    data.order_delivery_item[0].order_delivery_item.quantity *
    data.order_delivery_item[0].order_item.price

  const date = data.status === 'COMPLETED' ? data?.received_at ?? data.created_at : data.created_at

  return (
    <div className={styles.boxItem} style={{ borderRadius: 8 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          pr: 2,
          pl: 2,
          py: 1
        }}
      >
        {/* <p
          className={styles.headerText}
          style={{ color: '#ff3a59', cursor: 'pointer' }}
          onClick={() => showDetail(data)}
        >
          {data.order_delivery_number}
        </p>
        <p style={{ justifySelf: 'end', fontSize: 13 }}>{formatDateTime(date)}</p> */}
      </Box>
      <Box sx={{ px: 2, pb: 2 }}>
        <table className={styles.orderTable}>
          <tr>
            <td>PO Number</td>
            <td>:</td>
            <td>
              <p
                className={styles.headerText}
                style={{ color: '#ff3a59', cursor: 'pointer' }}
                onClick={() => showDetail(data)}
              >
                {data.order_delivery_number}
              </p>
            </td>
          </tr>
          <tr>
            <td>Date</td>
            <td>:</td>
            <td>{formatDateTime(date)}</td>
          </tr>
          <tr>
            <td>Requestor</td>
            <td>:</td>
            <td>{data.order_delivery_item[0].order_data.customer.name}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>:</td>
            <td>{data.status}</td>
          </tr>
        </table>
      </Box>
      <Box
        className='d-flex justify-content-between rounded grey-box'
        sx={{ px: 2, py: 1, backgroundColor: '#F0F4F7' }}
      >
        <p style={{ fontWeight: 'bold' }}>Total</p>
        <p style={{ fontWeight: 'bold' }}>{priceFormatLocal(total)}</p>
      </Box>
      <Box sx={{ mt: 1, pb: 2, px: 2 }}>
        <Button
          fullWidth
          variant='contained'
          sx={{ bgcolor: '#ff3a59' }}
          onClick={() => showDetail(data)}
        >
          Detail Order
        </Button>
      </Box>
    </div>
  )
}

export default OrderListDeliveryItemMobile
